import Vue from 'vue';
import Component from 'vue-class-component';
import { Icon } from 'wc-lib';
import { Service } from '../service';
import Config from '../config';
import { Notification } from '../model/notification';

require('../../icons/urgentp.svg');
require('../../icons/importantp.svg');
require('../../icons/infop.svg');


@Component({
  template: require('./persistent-notification.html'),
  components: {
    'wc-icon': Icon,
  }
})
export class PersistentNotification extends Vue {
  notification: Notification = null;
  showEntireNotification: boolean = false; 
  
  async mounted() {
    this.notification = (await Service.getPersistentNotification()).notification;
  }

  get fullText() {
    let entireText = `${this.notification.title} - ${this.notification.message}`;
    return entireText;
  }

  showNotification() {
    this.showEntireNotification = true;
  }

  closeNotification() {
    this.showEntireNotification = false;
  }
}



// WEBPACK FOOTER //
// src/components/persistent-notification.ts